"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("string.prototype.startswith");

var _debounce = _interopRequireDefault(require("./debounce"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var KeyPressOptionsHandler = function KeyPressOptionsHandler(options, callback) {
  var _this = this;

  var delay = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 100;

  _classCallCheck(this, KeyPressOptionsHandler);

  _defineProperty(this, "isDifferentKey", function (key) {
    return _this.lastKeyPressed !== key;
  });

  _defineProperty(this, "isBufferEmpty", function () {
    return _this.keyBuffer.length === 0;
  });

  _defineProperty(this, "enterIteratingMode", function () {
    if (!_this.iteratingMode) {
      _this.iteratingMode = true;
      _this.iteratingCounter = 0;

      var s = _this.keyBuffer.join('').toLowerCase();

      _this.iteratingModeOptions = _this.options.filter(function (o) {
        return o.name.startsWith(s) && o.disabled === false;
      });
    }
  });

  _defineProperty(this, "leaveIteratingMode", function () {
    if (_this.iteratingMode) {
      _this.iteratingMode = false;
    }
  });

  _defineProperty(this, "find", function () {
    var s = _this.keyBuffer.join('').toLowerCase();

    return _this.options.findIndex(function (o) {
      return o.name.startsWith(s) && o.disabled === false;
    });
  });

  _defineProperty(this, "findInIteratingMode", function () {
    var c = _this.iteratingModeOptions.length;

    if (c === 0) {
      _this.lastKeyPressed = null;
      return -1;
    }

    _this.iteratingCounter += 1;
    return _this.iteratingModeOptions[_this.iteratingCounter % c].index;
  });

  _defineProperty(this, "invokeCallback", function (args) {
    if (_this.callback) _this.callback(args);
  });

  _defineProperty(this, "handle", function (key) {
    if (_this.isDifferentKey(key)) {
      _this.keyBuffer.push(key);

      _this.lastKeyPressed = key;

      _this.leaveIteratingMode();

      _this.invokeCallback(_this.find());
    } else {
      // key pressed repeatedly ('a', 'a', ...), iterate over options starting with 'a'
      if (_this.isBufferEmpty()) {
        _this.keyBuffer.push(key);
      }

      _this.lastKeyPressed = key;

      _this.enterIteratingMode();

      _this.invokeCallback(_this.findInIteratingMode());
    }

    _this.clearKeyBuffer();
  });

  this.options = options ? options.map(function (o, i) {
    return {
      name: String(o.label || o.value).toLowerCase(),
      disabled: o.disabled ? o.disabled : false,
      index: i
    };
  }) : [];
  this.callback = callback;
  this.delay = delay;
  this.lastKeyPressed = null;
  this.keyBuffer = [];
  this.iteratingCounter = 0;
  this.iteratingMode = false;
  this.iteratingModeOptions = [];
  this.clearKeyBuffer = (0, _debounce.default)(function () {
    _this.keyBuffer = [];
  }, this.delay);
};

var _default = KeyPressOptionsHandler;
exports.default = _default;